// extracted by mini-css-extract-plugin
module.exports = {"title":"senha_title__1Kufh","pDesc":"senha_pDesc__1qzE5","box":"senha_box__3i5xS","button":"senha_button__1Ulth","desc":"senha_desc__1PlS7"};